<template>
    <div class="row g-6 g-xl-9">
        <div class="col-12 col-md-12 col-xl-12">
            <CardRh :processando="processando">
                <KDataTable :reload="reloadDatatable" :config="config" :pesquisar="false"> 
                    <th style="min-width:60px">ID</th>
                    <th>Disciplina</th>
                    <th>Quantidade</th> 
                    <th>Média</th> 
                    <th>Moda</th>
                    <th>Mediana</th>
                    <th>Variancia</th>
                    <th>Desvio Padrão</th>
                    <th>Amplitude</th> 
                    <th>Nota Max</th>
                    <th>Nota Min</th>
                    <template v-slot:filtros>  
                        <input type="text" data-kt-docs-table-filter="turmaId" v-model="turmaId" hidden/>  
                        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-3" v-if="tipos">
                            <div class="mb-2"> 
                                <label  for="disciplinaTipo" class="form-label">Tipo:</label>  
                                <Multiselect @change="refreshTable" :options="tipos_select" :searchable="true"  v-model="tipo_id" ></Multiselect>    
                            </div> 
                        </div>  
                        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-3" v-if="eixos">
                            <div class="mb-2"> 
                                <label  for="disciplinaTipo" class="form-label">Eixo:</label>  
                                <Multiselect @change="refreshTable" :options="eixos_select" :searchable="true"  v-model="eixo_id" ></Multiselect>    
                            </div> 
                        </div> 

                        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-3">
                            <div class="mb-2"> 
                                <label  for="disciplinaTipo" class="form-label">Tipo de Verificação:</label>  
                                <Multiselect @change="refreshTable" :options="tipo_notas_select" :searchable="true"  v-model="tipo_nota_id" ></Multiselect>    
                            </div> 
                        </div>


                        <input type="text" data-kt-docs-table-filter="tipoNota" v-model="tipo_nota_id" hidden/> 
                        <input type="text" data-kt-docs-table-filter="disciplinaTipo" v-model="tipo_id" hidden/> 
                        <input type="text" data-kt-docs-table-filter="eixoId" v-model="eixo_id" hidden/> 
                    </template>
                </KDataTable>
            </CardRh>
        </div>
    </div>
</template>

<script lang="ts"> 
    import { Options, Vue } from "vue-class-component";
    import { namespace } from 'vuex-class';
    const authStore = namespace('auth'); 
    import CardRh from   "@/components/cards/ManzaCard.vue"
    import DisciplinaService from   "@/service/v1/sigap/DisciplinaService"  
    import   SiteUtils   from '@/assets/ts/aplicacao/site'; 
    import KDataTable from   "@/components/datatable/newdatatable.vue"  
    import Multiselect from '@vueform/multiselect' 
    import { PerfilConfig } from "@/core/config/PerfisConfig";
    import { User } from "@/store/modules/AuthModule";
    import EixoService from '@/service/v1/sigap/EixoService';

    @Options({
        name: "TurmaDisciplinaEstatitica",
        components: {  CardRh , KDataTable, Multiselect },
    }) 
    export default class TurmaDisciplinaEstatitica extends Vue {
            
        @authStore.Getter
        public perfis!: any
        
        @authStore.Getter
		public currentUser!: User 

        public turmaId: any = null;

        public processando = false; 
        public reloadDatatable = false ;
        public config: any = null; 

        public service: any = null;   
        public eixoService = new EixoService();

        public modelo: any  = null ;  
        public dados: any  = null ;  
  
        public tipo_id: any = null;
        public tipos: any = null;

        public eixo_id: any = null;
        public eixos: any = null;

        public tipo_nota_id: any = null;

 
        get hasPermissao( ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.ChefeSTE ,  PerfilConfig.AuxSTE , PerfilConfig.LeituraDE ] ,  this.perfis); 
        }
 
        get hasPermissaoEditar( ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.ChefeSTE ,  PerfilConfig.AuxSTE ] ,  this.perfis); 
        }
         
        public refreshTable(){ 
            setTimeout(() => {
                this.reloadDatatable = !this.reloadDatatable ; 
            }, 300); 
        }
         
        public apertouEnter(e){ 
            if(e.key === 'Enter' || e.keyCode === 13){
                this.refreshTable();
            }
        }
  
       
        get tipos_select(){
            if(this.tipos){
                return this.tipos.map((item) => { return { value:  item.id , label: item.nome } });   
            }
            return null;
        }
         
        
        get tipo_notas_select(){ 
            return [ { value:  1 , label: 'VC' } , { value:  2 , label: 'VF' }  , { value:  3 , label: 'VR' }];
        }
         
 
        get eixos_select(){
            if(this.eixos){
                return this.eixos.map((item) => { return { value:  item.id , label: item.numero + ' - ' + item.descricao } });   
            }
            return null;
        }
         
        public getDisciplinaTipo(){   
            this.processando = true ; 
            this.service.getDisciplinaTipo(    ) 
            .then(response => {   
                this.tipos =  JSON.parse(JSON.stringify( response ));   
                this.processando = false ;    
            })
            .catch(error => { 
                this.processando = false ; 
            }); 
        } 
 
        public async buscarEixos(){   
            this.processando = true ; 
            this.eixoService.getAll( "take=100&turmaId=" + this.$route.params.id ) 
            .then(response => {   
                this.eixos = response.data;   
                this.processando = false ;    
            })
            .catch(error => { 
                this.processando = false ; 
            }); 
        }

        created(){    
            this.turmaId = this.$route.params.id; 
            this.config = {  ajax: {} , columns: [] , columnDefs: [] , order: [] }; 
            this.service = new DisciplinaService();  
            this.getDisciplinaTipo();
            this.buscarEixos();
            this.config.ajax = { 
                url: this.service.getApiUrl() + '/Estastisticas' ,
                data: function ( d ) {   
                    const dados = {
                        "Skip": d.start,
                        "Take": d.length,  
                        "turmaId": () => (document.querySelector('[data-kt-docs-table-filter="turmaId"]')! as HTMLInputElement).value , 
                        "eixoId": () => (document.querySelector('[data-kt-docs-table-filter="eixoId"]')! as HTMLInputElement).value , 
                        "tipo": () => (document.querySelector('[data-kt-docs-table-filter="disciplinaTipo"]')! as HTMLInputElement).value , 
                        "tipoNota": () => (document.querySelector('[data-kt-docs-table-filter="tipoNota"]')! as HTMLInputElement).value , 
                        "search": d.search.value
                    }
                    return dados; 
                } 
            }; 
            this.config.dom =   "<'row'<'col-xs-12'<'col-xs-12'><'col-xs-12' >>r>" + "<'row'<'col-xs-12't>>" + "<'row'<'col-lg-3'><'col-lg-6'><'col-lg-3'i>>";
            this.config.lengthMenu =  [ [ -1], [ "Todos"] ];
 
            this.config.columns = [  
                { data: "disciplina.id", name: "disciplina" ,  orderable: false }, 
                { data: "disciplina", name: "disciplina",  orderable: false }, 
                { data: "count", name: "count", class:'desktop',  orderable: false }, 
                { data: "media", name: "media", class:'desktop',  orderable: false }, 

                { data: "moda", name: "moda", searchable: false, class: "text-center desktop",  orderable: false },
                { data: "mediana", name: "mediana", searchable: false, class: "text-center desktop",  orderable: false },

                { data: "variancia", name: "variancia", class:'desktop',  orderable: false }, 
                { data: "desvio", name: "desvio", class:'desktop',  orderable: false }, 
                { data: "amplitude", name: "amplitude", searchable: false, class: "text-center desktop",  orderable: false },
                
                { data: "max", name: "max", searchable: false, class: "text-center desktop",  orderable: false },
                { data: "min", name: "min", searchable: false, class: "text-center desktop",  orderable: false }, 
            ];
             
            this.config.columnDefs = [  
                {
                    targets: 1,
                    render: function ( row, type, val, meta ) {  
                        return row != null ? row.descricao : '';  
                    }
                },  
                {
                    targets: 3,
                    render: function ( row, type, val, meta ) {  
                        return row != null ? row.toFixed(4) : '';  
                    }
                },  
                {
                    targets: 6,
                    render: function ( row, type, val, meta ) {  
                        return row != null ? row.toFixed(4) : '';  
                    }
                },  
                {
                    targets: 7,
                    render: function ( row, type, val, meta ) {  
                        return row != null ? row.toFixed(4) : '';  
                    }
                },  
                {
                    targets: 8,
                    render: function ( row, type, val, meta ) {  
                        return row != null ? row.toFixed(4) : '';  
                    }
                },  
            ];   
            
        }     
   
    } 
  
</script>